<template>
  <div class="scan-result" :class="modeClass">
    <div class="result-icon">
      <!-- Success -->
      <svg v-if="mode === 'success'" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/>
      </svg>
      <!-- Warning -->
      <svg v-else-if="mode === 'warning'" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2L1 21h22L12 2zm0 4.45L19.53 19H4.47L12 6.45zM11 10h2v5h-2zm0 6h2v2h-2z"/>
      </svg>
      <!-- Error -->
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12z"/>
      </svg>
    </div>

    <p v-if="mode !== 'error' && participant?.name" class="result-name">{{ participant.name }}</p>

    <p class="result-status">
      <span v-if="mode === 'success'">Check-in confirmado!</span>
      <span v-else-if="mode === 'warning'">Já estava confirmado</span>
      <span v-else>{{ errorMessage || 'QR Code inválido' }}</span>
    </p>

    <div v-if="mode !== 'error' && participant" class="result-meta">
      <EquipeChip v-if="participant.equipe" :equipe="participant.equipe" />
      <TransporteBadge v-if="participant.transporte" :value="participant.transporte" size="large" />
    </div>

    <button class="btn-primary restart-btn" @click="$emit('restart')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
      <span>Escanear outro</span>
    </button>
  </div>
</template>

<script>
import EquipeChip from './EquipeChip.vue'
import TransporteBadge from './TransporteBadge.vue'

export default {
  name: 'ScanResult',
  components: { EquipeChip, TransporteBadge },
  props: {
    mode: { type: String, required: true }, // 'success' | 'warning' | 'error'
    participant: { type: Object, default: null },
    errorMessage: { type: String, default: '' }
  },
  emits: ['restart'],
  computed: {
    modeClass() { return `result-${this.mode}` }
  }
}
</script>

<style scoped>
.scan-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-base);
  padding: var(--spacing-xl);
  width: 100%;
  max-width: 420px;
  text-align: center;
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}
.result-success .result-icon { color: var(--color-success); }
.result-warning .result-icon { color: var(--color-warning); }
.result-error .result-icon { color: var(--color-danger); }

.result-name {
  font-size: var(--text-2xl);
  font-weight: 800;
  color: var(--color-text-primary);
  margin: 0;
  word-break: break-word;
}
.result-status {
  font-size: var(--text-lg);
  font-weight: 700;
  margin: 0;
}
.result-success .result-status { color: var(--color-success); }
.result-warning .result-status { color: var(--color-warning); }
.result-error .result-status { color: var(--color-danger); }

.result-meta {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex-wrap: wrap;
  justify-content: center;
}
.restart-btn {
  justify-content: center;
  width: 100%;
  padding: 14px 20px;
  font-size: var(--text-md);
  margin-top: var(--spacing-sm);
}
</style>
